<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 17:51:56
 * @FilePath: \mrc-ess-fronted\src\Layout\components\ContentLayout.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-08 13:45:34
 -->
<template>
  <v-container class="pa-0" fluid>
    <ContentNav
      :hidden="hiddenNav"
      :title="title"
      :editBtn="editBtn"
      @triger="onTriger"
      :addBtn="addBtn"
      :manageBtn="manageBtn"
      :saveBtn="saveBtn"
      :exportBtn="exportBtn"
      :importBtn="importBtn"
      :delBtn="forceDelBtn || (delBtn && editBtn)"
    >
      <!-- 2020-10-23 mel buglist723 Edit Mode 不要有「刪除」的按鈕 -->
      <template v-slot:nav-actions>
        <slot name="nav-actions" />
      </template>
      <template v-slot:appendTitle>
        <slot name="appendTitle" />
      </template>
    </ContentNav>
    <!-- 筛选区域 -->
    <v-container
      class="pa-0 ma-0 d-flex flex-row flex-nowrap justify-end align-center"
      :class="filterable ? 'pb-3' : ''"
      fluid
    >
      <slot name="top-selection" :filter="onFilter" />
    </v-container>
    <!-- 筛选区域 -->

    <v-card
      class="rounded-lg pa-0 ma-auto form-container"
      :elevation="0"
      :class="
        ($vuetify.breakpoint.mobile ? '' : widthClass) + ' ' + backgroundClass
      "
    >
      <v-card-text :class="backgroundClass + ' pa-' + pad">
        <slot name="page-main" />
      </v-card-text>
      <slot name="page-actions" />
    </v-card>
    <slot name="tools-main" />
    <!-- 导入组件 -->
    <ImportIn
      v-if="importBtn && importOptions"
      :show="showImport"
      :options="importOptions"
      @close="showImport = false"
      @import="
        (e) => {
          $emit('import', e);
        }
      "
    />
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import ImportIn from "@/Layout/components/ImportIn/Files_ImportIn.vue";
export default {
  name: "ContentLayout",
  components: { ImportIn },
  beforeDestroy() {
    // if (this.changed) return;
  },
  destroyed() {},
  activated() {
    this.$emit("activated", this.SelectionRefresh);
  },
  deactivated() {
    this.$emit("deactivated", this.SelectionRefresh);
  },
  computed: {
    ...mapGetters(["companyLang", "isLoading", "SelectionRefresh"]),
    changed() {
      const that = this;
      var change = false;
      if (this.isLoading) return false;
      if (!this.checkData || !this.initData || !this.saveData) return change;
      if (this.checkData) {
        this.checkData.some((item) => {
          //null==''==undefined
          if (
            that.tranData(that.initData[item]) !==
            that.tranData(that.saveData[item])
          ) {
            // console.log(that.tranData(that.initData[item]));
            // console.log(that.tranData(that.saveData[item]));
            if (
              (that.tranData(that.initData[item]) == null &&
                that.tranData(that.saveData[item]) == "") ||
              (that.tranData(that.saveData[item]) == null &&
                that.tranData(that.initData[item]) == "")
            ) {
              //排除null和空字符串
              change = false;
              return false;
            } else {
              change = true;
              return true;
            }
          } else {
            change = false;
            return false;
          }
        });
      } else {
        change = false;
      }
      return change;
    },
    //手机和ipad
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
      }
    },
  },
  props: {
    hiddenNav: { default: false, type: Boolean },
    widthClass: { default: "", type: String },
    pad: { default: 8, type: [Number, String] },
    title: { defaule: "", type: String },
    initData: {
      defaule: undefined,
      type: [String, Number, Object, Array, Boolean],
    },
    filterable: { default: false, type: Boolean }, //可筛选，加下边距
    checkData: { defaule: null, type: [Array, String, Number, Object] },
    addBtn: { default: false, type: [Boolean, Number] },
    saveBtn: { default: false, type: [Boolean, Number] },
    delBtn: { default: false, type: [Boolean, Number] },
    backgroundClass: { default: "transparent ", type: String },
    manageBtn: { default: false, type: [Boolean, Number] },
    editBtn: { default: false, type: [Boolean, Number] },
    exportBtn: { default: false, type: [Boolean, Number] },
    importBtn: { default: false, type: [Boolean, Number] },
    importOptions: {
      //上传配置
      default: null,
      type: Object,
    },
    forceDelBtn: { default: false, type: Boolean }, //强制显示删除按钮，用于某些只有删除，没有编辑的页面，覆盖buglist723
  },
  watch: {
    isLoading() {
      if (this.initData || this.initData === "") {
        this.saveData = JSON.parse(JSON.stringify(this.initData));
      }
    },
    initData(val) {
      if ((val || val === "") && !this.saved) {
        this.saveData = JSON.parse(JSON.stringify(val));
      }
    },
    changed(val) {
      const that = this;
      this.$store.dispatch("setPageChange", val).then(() => {
        that.$emit("change", val);
      });
    },
    saveData(val) {
      this.saved = true;
    },
  },
  mounted() {
    const that = this;
    // 保存初始数据
    this.saveData = JSON.parse(JSON.stringify(this.initData)); //深拷贝
    this.Langobj = this.$getCommonLangKey(this.companyLang);
    //监听返回
    // this.$pushHistory();
    // 给window添加一个popstate事件，拦截返回键，执行this.closeViews事件，addEventListener需要指向一个方法
    // window.addEventListener(
    //   "popstate",
    //   () => {
    //     that.$toBack(that.changed);
    //   },
    //   false
    // );
  },
  data() {
    return {
      saved: false,
      saveData: undefined,
      Langobj: "",
      showImport: false,
    };
  },
  methods: {
    onFilter(page, perpage, data, tab) {
      const that = this;
      if (!page && !perpage) {
        if (tab !== undefined) {
          this.$emit("filter", null, tab);
        } else {
          this.$emit("filter", null);
        }
      } else {
        if (tab !== undefined) {
          this.$emit(
            "filter",
            { page: page, pagesize: perpage, data: data },
            tab
          );
        } else
          this.$emit("filter", { page: page, pagesize: perpage, data: data });
      }
    },
    tranData(data) {
      if (typeof data == "boolean") return data;
      else if (typeof data == "object") {
        if (data == []) return "";
        else if (data == {}) return "";
        else if (JSON.stringify(data) == JSON.stringify(this.Langobj))
          return "";
        else return data === null ? null : JSON.stringify(data);
      } else if (!data) return "";
      else if (data == undefined) return "";
      else if (typeof data == "number") return data.toString();
      else return data;
    },
    onTriger: function (action) {
      if (action == "import") {
        //导入文件操作
        this.showImport = !this.showImport;
      } else this.$emit(action, {});
    },
  },
};
</script>
